var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0533 0.661133C11.2738 0.697517 11.478 0.799652 11.6394 0.954157L20.3093 8.44554C20.7297 8.80227 20.9463 9.22908 20.5067 9.68136C20.0672 10.1336 19.6468 9.9935 19.2327 9.63677L17.8886 8.4965C17.7675 8.38184 17.5764 8.36909 17.5764 8.63027C17.5764 8.89145 17.5764 9.26729 17.5764 9.5858C17.5764 11.93 17.5764 14.2679 17.5764 16.593C17.5764 17.5358 17.0987 18.2175 16.3024 18.2812C15.3405 18.364 12.1745 18.2812 11.0342 18.2812C9.89395 18.2812 6.72795 18.3449 5.76605 18.2812C4.95703 18.2175 4.49201 17.5358 4.49201 16.593C4.49201 14.2488 4.49201 11.9109 4.49201 9.5858C4.49201 9.26729 4.49201 8.94878 4.49201 8.63027C4.49201 8.31176 4.29454 8.38184 4.17987 8.4965L2.83575 9.63677C2.42169 9.9935 1.96941 10.1336 1.56171 9.68136C1.15402 9.22908 1.33876 8.80227 1.75282 8.44554L10.4227 0.954157C10.5849 0.800936 10.7888 0.699008 11.0087 0.661133H11.1043H11.0533Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0087 13.2742C12.4019 13.2742 13.5313 12.1448 13.5313 10.7516C13.5313 9.35836 12.4019 8.22896 11.0087 8.22896C9.61554 8.22896 8.48613 9.35836 8.48613 10.7516C8.48613 12.1448 9.61554 13.2742 11.0087 13.2742Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.b77a00b7181ac51be951aa0a8e7b6105.svg";
export { ForwardRef as ReactComponent };